import { FormControlSizes, IconButton, IconName, Popover, Stack, Toggle, Tooltip, usePopoverState } from '@talos/kyoko';
import { useTradingSettings } from '../../../../providers/AppConfigProvider';

const GLOBAL_SHOW_ALL_DECIMALS_TOOLTIP =
  'Disabled and set to true because the global Show All Decimals setting is enabled.';

export const PricingPanelSettingsButton = () => {
  const { showAllDecimalsInBlotters, rfqPricingPanelShowAllDecimals, setRfqPricingPanelShowAllDecimals } =
    useTradingSettings();
  const popover = usePopoverState({
    closeOnClickOutside: true,
    trigger: 'click',
    placement: 'bottom-end',
    usePortal: false,
  });

  const showAllDecimals = showAllDecimalsInBlotters || rfqPricingPanelShowAllDecimals;

  return (
    <Popover {...popover}>
      <IconButton
        ghost
        icon={IconName.Cog}
        color="colorTextDefault"
        size={FormControlSizes.Default}
        data-testid="manual-rfq-pricing-settings-cog"
      />
      <Stack gap="spacing8">
        <Tooltip tooltip={showAllDecimalsInBlotters ? GLOBAL_SHOW_ALL_DECIMALS_TOOLTIP : undefined}>
          <div>
            <Toggle
              size={FormControlSizes.Small}
              checked={showAllDecimals}
              disabled={showAllDecimalsInBlotters}
              onChange={value => setRfqPricingPanelShowAllDecimals(value)}
              label="Show All Decimals"
              justifyContent="space-between"
              data-testid="manual-rfq-pricing-show-all-decimals-toggle"
            />
          </div>
        </Tooltip>
      </Stack>
    </Popover>
  );
};
